import React from 'react'
import PropTypes from 'prop-types'
import { loadImage } from 'integrations/unsplash'
import convertHexToRgba from 'lib/hex-to-rgba'
import { Box, Stack, Flex } from '@chakra-ui/react'
import dynamic from 'next/dynamic'

const RegisterWidgetTitle = dynamic(() => import(/* webpackChunkName: 'RegisterWidgetTitle' */ '../../../../../../components/home-page/views/sections/register-widget/components/title'))
const RegisterWidgetDescription = dynamic(() => import(/* webpackChunkName: 'RegisterWidgetDescription' */ '../../../../../../components/home-page/views/sections/register-widget/components/description'))
const RegisterWidgetCTA = dynamic(() => import(/* webpackChunkName: 'RegisterWidgetCTA' */ '../../../../../../components/home-page/views/sections/register-widget/components/cta'))

const RegisterWidgetLayoutTwo = ({ data, theme, meta }) => {
  return (
    <Flex
      alignItems='center'
      bg={theme.backgroundColor}
      background={`linear-gradient(
        ${convertHexToRgba(theme.backgroundColor, theme.bannerOpacity)},
        ${convertHexToRgba(theme.backgroundColor, theme.bannerOpacity)}
      ), url(${loadImage(data.image, meta.imageSize || 400)})`}
      backgroundPosition={`${data.imgFocalX}% ${data.imgFocalY}%`}
      backgroundRepeat='no-repeat'
      backgroundSize='cover'
      justifyContent='center'
      p={[4, 4, 16, 16]}
      aria-labelledby='altText-register-L2 registerWidgetTitle-register-L2 registerWidgetDescription-register-L2 registerWidgetCTA-register-L2'
      title={!data.altText ? '' : data.altText}
    >
      <Box
        maxWidth='2xl'
        p={[4, 4, 8, 8]}
        textAlign='center'
        w='full'
      >
        <Stack spacing={4}>
          <Box id='altText-register-L2' aria-hidden='true' style={{ position: 'absolute', width: '1px', height: '1px', margin: '-1px', padding: 0, border: 0, overflow: 'hidden', clip: 'rect(0, 0, 0, 0)' }}>
            {!data.altText ? '' : data.altText}
          </Box>
          <Box id='registerWidgetTitle-register-L2'>
            <RegisterWidgetTitle
              theme={theme}
              data={data}
            />
          </Box>
          <Box id='registerWidgetDescription-register-L2'>
            <RegisterWidgetDescription
              theme={theme}
              data={data}
            />
          </Box>
          <Box id='registerWidgetCTA-register-L2'>
            <RegisterWidgetCTA
              theme={theme}
              data={data}
            />
          </Box>
        </Stack>
      </Box>
    </Flex>
  )
}

RegisterWidgetLayoutTwo.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  meta: PropTypes.object
}

export default RegisterWidgetLayoutTwo
